// create shadow dom for svg (same as file_get_contents in php)

export function addSvgToDom() {
    customElements.define(
        "load-svg",
        class addSvgToDom extends HTMLElement {
            async connectedCallback() {
                const src = this.getAttribute("src");
                if (this.shadowRoot === null) {
                    this.attachShadow({ mode: "open" }).innerHTML = await (
                        await fetch(`${window.location.origin}${src}`)
                    ).text();

                    if (this.shadowRoot) {
                        const style: string | Node = this.querySelector(
                            "style",
                        ) as string | Node;
                        // @ts-ignore
                        this.shadowRoot?.append(style);
                    }
                }
            }
        },
    );
}
